import { ICON_NAME_ALIASES } from './icon-aliases';

/**
 * Normalize a persisted RuleCMS icon name to the current Lucide kebab key.
 * Empty / non-string input yields null.
 */
export const resolveIconName = (name: unknown): string | null => {
  if (typeof name !== 'string') return null;
  const trimmed = name.trim();
  if (!trimmed) return null;

  // Authors may paste PascalCase from Lucide docs; normalize to kebab.
  const kebab = trimmed
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();

  return ICON_NAME_ALIASES[kebab] ?? kebab;
};
